import { Component, OnInit } from '@angular/core';
import { FiltrosCustosService } from '../../../../filters/filtros-custos.service';
import { IntegradorService } from '../../../../services/integrador.service';

@Component({
  selector: 'app-custodepreciacao',
  templateUrl: './custodepreciacao.component.html',
  styleUrl: './custodepreciacao.component.css'
})
export class CustodepreciacaoComponent implements OnInit {
  despesas: any[] = [];
  totalRecords: number = 0;
  loading: boolean = false;

  dataInicio: string = '';
  dataFim: string = '';
  instancia: string = '';

  constructor(private integradorService: IntegradorService, private filterService: FiltrosCustosService) {}

  ngOnInit() {
    this.loading = true;
    this.getFiltros();
  }

  loadDepreciacoes(event: any) {

    if (this.instancia != '' && this.dataInicio != '' && this.dataFim != '') {
    this.loading = true;
    const sortDirection = event.sortOrder === 1 ? 'asc' : 'desc';
    this.integradorService
      .getDepreciacoesCusto(
        event.first / event.rows,
        event.rows,
        event.sortField,
        sortDirection,
        this.instancia,
        this.dataInicio,
        this.dataFim
      )
      .subscribe((data) => {
        this.despesas = data.content;
        this.totalRecords = data.totalElements;
        this.loading = false;
      });
    }else {
      this.loading = false
    }
  }

  getFiltros(){
    this.filterService.currentInstancia.subscribe((instancia) => {
      this.instancia = instancia;
      this.loadDepreciacoes({
        first: 0,
        rows: 10,
        sortField: 'cdEmpresaErp',
        sortOrder: 1,
      });
    });

    this.filterService.currentDataInicio.subscribe((inicio) => {
      this.dataInicio = inicio;
      this.loadDepreciacoes({
        first: 0,
        rows: 10,
        sortField: 'cdEmpresaErp',
        sortOrder: 1,
      });
    });

    this.filterService.currentDataFim.subscribe((fim) => {
      this.dataFim = fim;
      this.loadDepreciacoes({
        first: 0,
        rows: 10,
        sortField: 'cdEmpresaErp',
        sortOrder: 1,
      });
    });
  }
}
